import React from 'react'
import { DeleteOutlinedIcon } from '@common/icons'
import {
  IconButton,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
  Popover,
  Typography,
} from '@common/components'
import { useClassroomDeleteClassroomTaskMutation } from '@app/services/auto-generated/classroom'
import MoreHorizIcon from '@mui/icons-material/MoreHoriz'
import { GridDragIcon } from '@mui/x-data-grid'

interface MenuNoteProps {
  task: object
  listeners?: any
  attributes?: any
  isDragging?: boolean
}
const MenuNote: React.FC<MenuNoteProps> = (props) => {
  const { task } = props
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null)
  const open = Boolean(anchorEl)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClosePopover = () => {
    setAnchorEl(null)
  }

  const [deleteTask] = useClassroomDeleteClassroomTaskMutation()

  const handleDeleteNote = async () => {
    await deleteTask({ taskId: task?.id }).unwrap()
    handleClosePopover()
  }

  return (
    <>
      <IconButton
        sx={{ position: 'absolute', top: 0, right: 0, zIndex: 10 }}
        color='dark'
        onClick={handleClick}
      >
        <MoreHorizIcon />
      </IconButton>
      <IconButton
        sx={{
          cursor: props.isDragging ? 'grabbing' : 'grab',
          '&:hover, &:active': {
            backgroundColor: 'transparent',
          },
          position: 'absolute',
          top: 0,
          left: 0,
          zIndex: 10,
          color: '#6f717180',
        }}
        {...props.listeners}
        {...props.attributes}
      >
        <GridDragIcon />
      </IconButton>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClosePopover}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
          sx: { borderRadius: '4px' },
        }}
      >
        <MenuList>
          <MenuItem onClick={handleDeleteNote}>
            <ListItemIcon>
              <DeleteOutlinedIcon color='error' fontSize='small' />
            </ListItemIcon>
            <ListItemText>
              <Typography color='error'>Remove</Typography>
            </ListItemText>
          </MenuItem>
        </MenuList>
      </Popover>
    </>
  )
}

export default MenuNote
